import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Translate } from 'react-redux-i18n'

import './style.css'

const SectionHeader = (props) => {
  const { anchorName, titleI18nKey } = props
  return <Grid item container className="section-header" direction="row" component="a" name={anchorName}>
    <Translate className="section-title" value={titleI18nKey} />
  </Grid>
}

export default SectionHeader


// WEBPACK FOOTER //
// ./src/components/Section/SectionHeader.js